import React from "react";
import {
  VideoContainer,
  VideoBackground,
  Content,
  Heading,
  Paragraph,
  LinkButton,
} from '../styles/BackgroundVideoStyle.js';
import { Link } from "react-router-dom";


const BackgroundVideo = () => {
  return (
    <VideoContainer>
      <VideoBackground autoPlay muted loop>
        <source src="/assets/videos/intro.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </VideoBackground>

      <Content>
        <Paragraph>Open the Door to Wilder Possibilities</Paragraph>
        <Heading>Sophia Matthew Group</Heading>
        <Paragraph className="mt-5">Alex Turner | CA DRE# 0123456789</Paragraph>
        <div className="d-flex gap-5">
          <LinkButton as={Link} to="/listFeaturedProperties">
            SEARCH PROPERTIES
          </LinkButton>
          <LinkButton as={Link} to="/neighborhoods">
            EXPLORE THE AREA
          </LinkButton>
        </div>
      </Content>
    </VideoContainer>
  );
};

export default BackgroundVideo;
